import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore"; // Firestore imports
import { db } from "../config/Firebase"; // Import your Firebase configuration
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

export default function Category() {
  const [products, setProducts] = useState([]); // State for products
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for errors
  const navigate = useNavigate(); // Define navigate using useNavigate hook

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const sunglassessRef = collection(db, "Types"); // Reference to the 'Types' collection
        const querySnapshot = await getDocs(sunglassessRef);
        const fetchedProducts = querySnapshot.docs.map((doc) => ({
          id: doc.id, // Document ID
          ...doc.data(), // Spread the document data
        }));
        setProducts(fetchedProducts); // Update state with fetched products
      } catch (err) {
        console.error("Error fetching products:", err);
        setError(err.message); // Set error message
      } finally {
        setLoading(false); // Set loading to false
      }
    };

    fetchProducts();
  }, []);

  const handleProductClick = (category) => {
    // Navigate based on the category
    if (category === "FullFrame") {
      navigate("/ffa");
    } else if (category === "Sunglasses") {
      navigate("/sga");
    } else if (category === "HalfFrame") {
      navigate("/hfa");
    } else if (category === "DesignerMetal Frame") {
      navigate("/dma");
    } else if (category === "FrameLess") {
      navigate("/fla");
    }else if (category === "SafetyGlassess") {
      navigate("/sa");}
  };

  if (loading) {
    return <p className="text-center text-gray-600">Loading products...</p>;
  }

  if (error) {
    return (
      <p className="text-center text-red-500">
        Error loading products: {error}
      </p>
    );
  }

  if (products.length === 0) {
    return (
      <p className="text-center text-gray-500">
        No products found in the "Types" collection.
      </p>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl Rubik-Bold text-black px-2">Frame Types</h1>
      </div>
      <div className="flex overflow-x-auto space-x-4 scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200">
        {products.map((product) => (
          <div
            key={product.id} // Unique key for each product
            className="bg-white rounded-lg shadow-lg p-4 w-60 h-auto flex-shrink-0 transition-transform transform hover:scale-105"
            onClick={() => handleProductClick(product.Category)} // Navigate on click
          >
            {/* Product Image */}
            <div className="w-full h-32 flex items-center justify-center bg-gray-100 rounded-md mb-2 overflow-hidden">
              {product.ImageUrl ? (
                <img
                  src={product.ImageUrl}
                  alt={product.Name || "Product Image"}
                  className="h-full object-contain"
                />
              ) : (
                <p className="text-gray-400 italic">No image available</p>
              )}
            </div>

            {/* Product Details */}
            <div className="text-sm">
              <div className="flex justify-between mb-1">
                <p className="font-semibold text-gray-800">{product.Category || "N/A"}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
